import { Page, PaginationParams } from '@/shared/api/pagination';
import type {
  AccessRuleBriefDashboardDTOResponse,
  AccessRuleDashboardCreateRequest,
  AccessRuleDashboardResponse,
  AccessRuleDashboardUpdateRequest,
} from '@/entities/user/access-rule';
import type { AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

const baseURLOverride = {
  baseURL: '/api/srm/v4',
};

export class AccessRulesDashboardsApi {
  static getRules(params: PaginationParams, options: AxiosRequestConfig = {}) {
    return srmInstance.get(`dashboards/rules`, {
      ...options,
      params,
    });
  }

  static getRuleById(id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.get(`dashboards/rule/${id}`, options);
  }

  static getRuleByIdV4(id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.get(`dashboards/rule/${id}`, {
      ...options,
      ...baseURLOverride,
    });
  }

  static updateRule(
    rule_id: string,
    payload: AccessRuleDashboardUpdateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.put<AccessRuleDashboardResponse>(
      `/dashboards/rule/${rule_id}`,
      payload,
      options,
    );
  }

  static updateRuleV4(
    rule_id: string,
    payload: AccessRuleDashboardUpdateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.put<AccessRuleDashboardResponse>(
      `/dashboards/rule/${rule_id}`,
      payload,
      {
        ...options,
        ...baseURLOverride,
      },
    );
  }

  static createRule(
    payload: AccessRuleDashboardCreateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.post<AccessRuleDashboardResponse>(
      `/dashboards/rule`,
      payload,
      options,
    );
  }

  static createRuleV4(
    payload: AccessRuleDashboardCreateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.post<AccessRuleDashboardResponse>(
      `/dashboards/rule`,
      payload,
      {
        ...options,
        ...baseURLOverride,
      },
    );
  }

  static deleteRule(rule_id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.delete(`dashboards/rule/${rule_id}`, options);
  }

  static deleteRuleV4(rule_id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.delete(`dashboards/rule/${rule_id}`, {
      ...options,
      ...baseURLOverride,
    });
  }

  static getActions(options: AxiosRequestConfig = {}) {
    return srmInstance.get(`dashboards/rules/actions`, {
      ...options,
      ...baseURLOverride,
    });
  }

  static getAccesses(options: AxiosRequestConfig = {}) {
    return srmInstance.get(`dashboards/rules/accesses`, {
      ...options,
      ...baseURLOverride,
    });
  }

  static getRulesBrief(
    params: PaginationParams,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<Page<AccessRuleBriefDashboardDTOResponse>>(
      `/dashboards/rules_brief`,
      {
        ...options,
        ...baseURLOverride,
        params,
      },
    );
  }
}